<script setup>
const props = defineProps({
    id: String,
    title: String
});
</script>

<template>
    <div class="modal-header">
        <h5 class="modal-title" :id="`${id}Label`">{{ title }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"></button>
    </div>
</template>

<script>
export default {
    name: 'ModalHeader'
};
</script>

<style scoped></style>
